import Vue from 'vue'
import App from './App.vue'
import router from "./router";

import vueSmoothScroll from 'vue2-smooth-scroll'
Vue.use(vueSmoothScroll);

import VueCarousel from 'vue-carousel';
Vue.use(VueCarousel);

import VTooltip from 'v-tooltip';
Vue.use(VTooltip)

import { registerComponents } from "./components";
registerComponents();

Array.prototype.shuffle = function() {
  var i = this.length, j, temp;
  if ( i == 0 ) return this;
  while ( --i ) {
     j = Math.floor( Math.random() * ( i + 1 ) );
     temp = this[i];
     this[i] = this[j];
     this[j] = temp;
  }
  return this;
}

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
